import { useEffect, useState } from 'react';

import { Session } from './session';

/**
 * Returns a counter that bumps on every `Session.reset()` so consumers can
 * include it in `useEffect` deps and re-run logic when the session has been reset.
 *
 *   const sessionResetWatcher = useSessionResetWatcher();
 *   const userKey = Session.getInstance().data.id;
 *   useEffect(() => { ... }, [userKey, sessionVersion]);
 */
export function useSessionResetWatcher(): number {
  const [resetSessionWatcherCount, setResetSessionWatcherCount] = useState(0);
  useEffect(() => Session.onReset(() => setResetSessionWatcherCount((v) => v + 1)), []);
  return resetSessionWatcherCount;
}
